import { Clear } from '@mui/icons-material';
import { Select, MenuItem, OutlinedInput, InputAdornment, IconButton, Typography } from '@mui/material';
import { forwardRef, useMemo } from 'react';

const ITEM_HEIGHT = 46;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 },
  },
};

export const SelectField = forwardRef(
  ({ value = '', onChange, options = [], valueName = 'value', optionName = 'name', ...props }, ref) => {
    const memoizedOptions = useMemo(() => options, [options]);

    const handleClear = (e) => {
      e.stopPropagation(); // prevent dropdown from opening
      onChange('');
    };

    return (
      <Select
        ref={ref}
        MenuProps={MenuProps}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        input={
          <OutlinedInput
            endAdornment={
              value ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClear}
                    edge="end"
                    sx={{ right: '15px' }}
                  >
                    <Clear fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null
            }
            label={props.label}
          />
        }
        {...props}
      >
        {memoizedOptions.length === 0 ? (
          <MenuItem disabled>No options available</MenuItem>
        ) : (
          memoizedOptions.map((option) => (
            <MenuItem
              key={option[valueName] ?? option}
              value={option[valueName] ?? option}
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: '100%',
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: '14px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: 1,
                  minWidth: 0,
                }}
              >
                {option[optionName] ?? option}
              </Typography>
            </MenuItem>
          ))
        )}
      </Select>
    );
  }
);

SelectField.displayName = 'SelectField';
